/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Field, FieldArray } from 'formik';
import CityField from 'components/CityField';
import CountryField from 'components/CountryField';
import StateField from 'components/StateField';
import FormikInputField from 'components/Fields/FormikInputField';
import { Button, Col, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';

const AddressField = ({ values }) => {
  if (!values?.addresses) return '';
  return (
    <div>
      {' '}
      <FieldArray name="addresses">
        {({ push, remove }) => (
          <div className="position-relative">
            {values?.addresses.map((_, index) => (
              <div key={index}>
                <CardWithTitle
                  className="position-relative"
                  title={`Address ${index + 1}`}
                >
                  <Row>
                    <Col sm={5}>
                      <Field
                        id={`addresses[${index}].street`}
                        name={`addresses[${index}].street`}
                        type="text"
                        label="Street"
                        component={FormikInputField}
                      />
                    </Col>
                    <Col sm={5}>
                      <CountryField
                        id="country"
                        label="Country"
                        name={`addresses[${index}].country`}
                      />
                    </Col>
                    <Col sm={5}>
                      <StateField
                        id="state"
                        label="State"
                        name={`addresses[${index}].state`}
                        // setFieldValue={setFieldValue}
                        countryId={values.addresses[index].country?.id}
                      />
                    </Col>
                    <Col sm={5}>
                      <CityField
                        id="city"
                        label="City"
                        name={`addresses[${index}].city`}
                        countryId={values.addresses[index].country?.id}
                        stateId={values.addresses[index].state?.id}
                      />
                    </Col>
                    <Col sm={5}>
                      <Field
                        id={`addresses[${index}].pinCode`}
                        name={`addresses[${index}].pinCode`}
                        type="text"
                        label="Pincode"
                        component={FormikInputField}
                      />
                    </Col>
                  </Row>
                  <Button
                    color="danger"
                    outline
                    className="remove-btn border-0 rounded-0 py-1 f-14 position-absolute"
                    type="button"
                    onClick={() => remove(index)}
                  >
                    Remove
                  </Button>
                </CardWithTitle>
              </div>
            ))}
            <Button
              type="button"
              color="primary"
              size="sm"
              className="text-decoration-none f-14 mb-3"
              onClick={() =>
                push({ street: '', country: '', state: '', city: '' })
              }
            >
              Add Address
            </Button>
          </div>
        )}
      </FieldArray>
    </div>
  );
};

export default AddressField;

// /* eslint-disable prefer-const */
// import { useLazyQuery } from '@apollo/client';
// import FormikInputField from 'components/Fields/FormikInputField';
// import ReactSelect from 'components/Fields/ReactSelect';
// import Loader from 'components/common/Loader';
// import { Field } from 'formik';
// import {
//   CITY_BY_COUNTRY_AND_STATE,
//   STATES_BY_COUNTRY,
// } from 'pages/MarketListing/MarketListingGraphQL';
// import React, { useEffect, useState } from 'react';
// import { Col, Row } from 'reactstrap';
// import AddressField from './index';

// const AddressField = ({ stateID, countryID = 101, setFieldValue }) => {
//   const [ids, setIds] = useState({ sId: stateID, cId: countryID });
//   const [countryCurrencies, { data: countryData, loading, error }] =
//     useLazyQuery(STATES_BY_COUNTRY, {
//       fetchPolicy: 'network-only',
//     });
//   const [statesByCountry, { data }] = useLazyQuery(STATES_BY_COUNTRY, {
//     fetchPolicy: 'network-only',
//   });

//   const [citiesByStateAndCountry, { data: citiesData }] = useLazyQuery(
//     CITY_BY_COUNTRY_AND_STATE,
//     {
//       //   variables: {
//       //     state: stateID,
//       //     country: countryID,
//       //   },
//       fetchPolicy: 'network-only',
//     }
//   );

//   const callCountry = async () => {
//     await countryCurrencies();
//   };

//   const callState = async () => {
//     await statesByCountry({
//       variables: {
//         country: ids.cId,
//       },
//     });
//   };

//   const callCity = async () => {
//     await citiesByStateAndCountry({
//       variables: {
//         state: ids.sId,
//         country: ids.cId,
//       },
//     });
//     // console.log('citiesData', citiesData);
//     // if (citiesData?.citiesByStateAndCountry?.length) {
//     //   const cityData = citiesData.citiesByStateAndCountry.map((val) => {
//     //     return {
//     //       id: val.cityName,
//     //       label: val.cityName,
//     //     };
//     //   });
//     //   setCityOptions(cityData);
//     // }
//   };
//   useEffect(() => {
//     callCountry();
//     callState();
//     callCity();
//   }, [ids]);

//   const onStateChange = (value) => {
//     setIds({ ...ids, sId: value.id });
//     setFieldValue('state', value);
//     setFieldValue('city', { id: '', label: '' });
//   };

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading) return <Loader />;

//   return (
//     <div>
//       <Row>
//         <Col sm={5}>
//           <Field
//             label="Street Address"
//             name="street_address"
//             type="text"
//             component={FormikInputField}
//           />
//         </Col>
//         <Col sm={5}>
//           <Field
//             label="Country"
//             name="country"
//             type="select"
//             component={ReactSelect}
//             data={data?.statesByCountry.map((val) => {
//               return {
//                 id: val.id,
//                 label: val.stateName,
//               };
//             })}
//             keys={{ id: 'id', label: 'label' }}
//             getOptionValue={(option) => option.id}
//             getOptionLabel={(option) => option.label}
//             onChange={onStateChange}
//           />
//         </Col>
//       </Row>
//       <Row>
//         <Col sm={5}>
//           <Field
//             label="State"
//             name="state"
//             type="select"
//             component={ReactSelect}
//             data={data?.statesByCountry.map((val) => {
//               return {
//                 id: val.id,
//                 label: val.stateName,
//               };
//             })}
//             keys={{ id: 'id', label: 'label' }}
//             getOptionValue={(option) => option.id}
//             getOptionLabel={(option) => option.label}
//             onChange={onStateChange}
//           />
//         </Col>
//         <Col sm={5}>
//           <Field
//             label="City"
//             name="city"
//             type="select"
//             component={ReactSelect}
//             data={citiesData?.citiesByStateAndCountry.map((val) => {
//               return {
//                 id: val.id,
//                 label: val.cityName,
//               };
//             })}
//             keys={{ id: 'id', label: 'label' }}
//             getOptionValue={(option) => option.id}
//             getOptionLabel={(option) => option.label}
//             //   onCityChange={onCityChange}
//           />
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default AddressField;
